import React from 'react'

const Cells = (props) => {
    return(
        <>
            <td className='bigRow'>{props.day}</td>
            <tr>
                <td className='littleRowHTwoOh'>H2OL</td>
                <td className='littleRowHTwoOh'>{props.routeAmount}</td>
                <td className='littleRowHTwoOh'>{props.miles}</td>
                <td className='littleRowHTwoOh'>{props.LWP}</td>
                <td className='littleRowHTwoOh'>{props.LVP}</td>
                <td className='littleRowHTwoOh'>{props.jumper}</td>
                <td className='littleRowHTwoOh'>{props.Training}</td>
                <td className='littleRowHTwoOh'>{parseFloat(props.support).toFixed(2)}</td>
                <td className='littleRowHTwoOh'>{props.R2 ? props.R2 : 0}</td>
                <td className='littleRowHTwoOh'>{props.R4 ? props.R4: 0}</td>
                <td className='littleRowHTwoOh'>{props.R6 ? props.R6 : 0}</td>
                <td className='littleRowHTwoOh'></td>
                <td className='littleRowHTwoOh'></td>
                <td className='littleRowHTwoOh'></td>
            </tr>
        </>
    )
}

export default Cells